module.exports = require("lodash/values");